import React, { useState } from 'react';
import axios from 'axios';
import DataChart from './DataChart';
import PigletGame from './CoinGame';
import SavingsChecker from './SavingsChecker';

// Get the API URL from environment variable or fallback to localhost for development
// For production deployment on Render.com
const API_URL = process.env.REACT_APP_API_URL || 
                (window.location.hostname === 'localhost' 
                  ? 'http://localhost:5000' 
                  : 'https://isdestichtinggezond-nl.onrender.com');

console.log('Using API URL:', API_URL);

function App() {
  const [info, setInfo] = useState(null);
  const [chartData, setChartData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showChart, setShowChart] = useState(false);
  const [showGame, setShowGame] = useState(false);
  const [showSavings, setShowSavings] = useState(false);
  const [logoClickCount, setLogoClickCount] = useState(0);
  const [secretTriggerClicks, setSecretTriggerClicks] = useState(0);

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);

      // Fetch both endpoints in parallel for faster loading
      const [infoResponse, financialResponse] = await Promise.all([
        axios.get(`${API_URL}/api/info`),
        axios.get(`${API_URL}/api/financial`)
      ]);

      setInfo(infoResponse.data);
      setChartData(financialResponse.data);

      // Show chart immediately
      setShowChart(true);
    } catch (err) {
      setError('Ah kankah, de backend is offline. Kom later even terug.');
      console.error('Error fetching data:', err);
    } finally {
      setLoading(false);
    }
  };

  const resetView = () => {
    setInfo(null);
    setChartData(null);
    setShowChart(false);
    setError(null);
  };

  const handleLogoClick = () => {
    // Secret trigger - click the logo 5 times to reveal the game
    const newCount = logoClickCount + 1;
    setLogoClickCount(newCount);
    
    if (newCount >= 5) {
      setShowGame(true);
      setLogoClickCount(0);
    }
  };

  const handleSecretAreaClick = () => {
    // Alternative secret trigger - bottom right corner
    const newCount = secretTriggerClicks + 1;
    setSecretTriggerClicks(newCount);
    
    if (newCount >= 3) {
      setShowGame(true);
      setSecretTriggerClicks(0);
    }
  };

  return (
    <div className="app">
      {/* Hidden game trigger in bottom right corner */}
      <div 
        className="game-trigger" 
        onClick={handleSecretAreaClick}
        title={secretTriggerClicks > 0 ? `${3 - secretTriggerClicks} clicks remaining` : ''}
      />
      
      {/* Header image outside container - now shown on all screens */}
      <div className="header-image">
        <img 
          src="/header-image.png" 
          alt="Header" 
          onClick={handleLogoClick}
          title={logoClickCount > 0 ? `${5 - logoClickCount} clicks remaining` : ''}
        />
      </div>
      
      <div className={`container ${showChart ? 'expanded' : ''}`}>
        {!info ? (
          <>
            <h1>Welkom bij isdestichtinggezond.nl!</h1>
            <p>Klik op een van de onderstaande knoppen om de financiële gezondheid van de Stichting te bekijken of je lustrum spaargeld te controleren.</p>

            <div className="button-group">
              <button onClick={fetchData} disabled={loading} className="primary-button">
                {loading ? (
                  <span className="loading">
                    <span className="spinner"></span>
                    Factuah checken...
                  </span>
                ) : (
                  'Zijn we gezond?'
                )}
              </button>

              <button onClick={() => setShowSavings(true)} className="secondary-button">
                Lustrum Spaargeld
              </button>
            </div>

            {error && <p style={{ color: '#ffcccc', marginTop: '20px' }}>{error}</p>}
          </>
        ) : (
          <>
            <div className={showChart ? "content-section narrow" : "content-section"}>
              <h1>{info.title}</h1>
              <div className={`info-container ${info ? 'visible' : ''}`}>
                <p>{info.message}</p>
                <p>{info.details}</p>
              </div>
            </div>
            
            {showChart && chartData && (
              <div className="chart-section">
                <DataChart data={chartData} />
              </div>
            )}
            
            <div className="button-container">
              <button onClick={resetView} className="close-button">
                Terug naar start
              </button>
            </div>
          </>
        )}
      </div>
      
      {/* Small hidden hint */}
      <div className="footer-hint">
        <span>© 2025 - Is de Stichting Gezond? - Bestuah IX </span>
        <span className="hint-text">Psst... Er zit een verborgen spel ergens op deze pagina.</span>
      </div>
      
      {/* Piglet Game */}
      {showGame && <PigletGame onClose={() => setShowGame(false)} />}

      {/* Savings Checker */}
      {showSavings && <SavingsChecker onClose={() => setShowSavings(false)} />}
    </div>
  );
}

export default App; 